import { Block } from 'prismarine-block';
import { CustomWorld } from './world';
export declare const server: (serv: Server, { version }: Options) => void;
declare global {
    interface Server {
        redstoneConsumers: {
            [block: string]: (data: {
                block: Block;
                world: CustomWorld;
                source: Block;
            }) => any;
        };
    }
}
